import React, { useState, useEffect } from "react";

import {
  Box,
  Flex,
  Link,
  Text,
  useDisclosure,
  useBreakpointValue,
  Icon,
  Tooltip,
  MenuButton,
  MenuList,
  MenuItem,
  Menu,
  TabPanels,
  TabPanel,
  SimpleGrid,
  List,
  ListItem,
} from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";
import { Link as ReactLink, useHistory } from "react-router-dom";
import { TableRelatorioPendencia } from "../../../components/TableRelatorioPendencia";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { RiFileExcel2Line } from "react-icons/ri";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { FiltersRelatorioCriancaGeral } from "../../../components/FiltersRelatorioCriancaGeral";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import {
  servicoAcolhimentoFunc,
  criancaFunc,
} from "../../../../helpers/Funcionalidades";
import Swal from "sweetalert2";
import RelatorioService from "../../../../main/services/RelatorioService";
import SemRegistros from "../../../components/SemRegistros";
import { PopoverGenero } from "../../../components/PopoverGenero";
import { format } from "date-fns";
import { RiPushpinLine } from "react-icons/ri";
import { PrintButtonRelatorioCriancaGeral } from "../../../components/PrintButtonRelatorioCriancaGeral";
import { cleanObject } from "../../../utils/cleanObject";
import { formatDateToISOWithNow } from "../../../utils/formatDateToISOWithNow";
import { parseBoolean } from "../../../utils/parseBoolean";

export const RelatoriosCriancaAdolescenteGeral = () => {
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ, usuarioLogado } = useAppContext();

  const history = useHistory();

  const [mostrarTabela, setMostrarTabela] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const placement = useBreakpointValue({ md: "left" });

  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const storage = JSON.parse(
    sessionStorage.getItem("relatorio-crianca-adolescente-geral-filter"),
  );

  const columnsOrgaos = [
    storage?.idMunicipioOrgao?.[0]?.length > 0,
    storage?.idPromotoriaOrgaos?.[0]?.length > 0,
    storage?.idVaraOrgaos?.[0]?.length > 0,
  ].filter(Boolean).length;

  const riscoAlert = (id, idPJCrianca, idMovimento) => {
    if (
      idMovimento !== 2 &&
      !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      history.push("/crianca/" + id);
    }
  };

  const columns = [
    {
      Header: "Nome/Nome Social",
      accessor: "nomeCrianca",
      Cell: (props) => {
        const id = props?.row?.original?.idCrianca;
        let name = props?.row?.original?.nomeCrianca;
        const descricaoTipoSituacao =
          props?.row?.original?.descricaoTipoSituacao;
        const temRiscoVida =
          props?.row?.original?.riscoVida === "S" ? true : false;
        const idMovimento = props?.row?.original?.idMovimento;
        const maioridade = props?.row?.original?.maioridade === true;

        if (props?.row?.original?.nomeSocial) {
          name = name + " / " + props.row.original.nomeSocial;
        }

        return (roleKeycloack &&
          roleKeycloack.includes(criancaFunc.visualizar)) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM,
          ) ? (
          !temRiscoVida ? (
            <Link
              wordBreak={"break-all"}
              title={name}
              as={ReactLink}
              to={"/crianca/" + id}
            >
              <Flex alignItems="center" gap={2}>
                {maioridade ? (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                ) : descricaoTipoSituacao === "Acolhido" &&
                  idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          ) : (
            <Link
              wordBreak={"break-all"}
              title={name}
              onClick={() =>
                riscoAlert(
                  id,
                  props?.row?.original?.servicoAcolhimentoAtual
                    ?.idPessoaJuridica,
                  idMovimento,
                )
              }
            >
              <Flex alignItems="center" gap={2}>
                {maioridade ? (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                ) : descricaoTipoSituacao === "Acolhido" &&
                  idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          )
        ) : !temRiscoVida ? (
          <Flex alignItems="center" gap={2}>
            {maioridade ? (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            ) : descricaoTipoSituacao === "Acolhido" ||
              descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        ) : (
          <Flex alignItems="center" gap={2}>
            {maioridade ? (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            ) : descricaoTipoSituacao === "Acolhido" ||
              descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        );
      },
    },
    {
      Header: "Gênero",
      accessor: "genero",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Data de Nascimento",
      accessor: "dataNascimento",

      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },

    {
      Header: "Idade",
      accessor: "idade",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
    {
      Header: "Filiação",
      accessor: "filiacoes",
      sortType: (rowA, rowB, id, desc) => {
        const filiacoesA = rowA?.original?.filiacoes?.length
          ? rowA.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        const filiacoesB = rowB?.original?.filiacoes?.length
          ? rowB.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        return filiacoesA.localeCompare(filiacoesB, "pt-BR");
      },
      Cell: (props) => {
        return props?.value
          .sort((a, b) =>
            a.descricaoTipoRelacionamento.localeCompare(
              b.descricaoTipoRelacionamento,
            ),
          )
          .map((filiacao, index) => {
            return (
              <React.Fragment key={index}>
                <span style={{ whiteSpace: "nowrap" }}>
                  {filiacao?.nome}{" "}
                  <Text as="span" textTransform="capitalize">
                    ({filiacao?.descricaoTipoRelacionamento.toLowerCase()})
                  </Text>
                </span>
                {props.value.length - 1 !== index && <br />}
              </React.Fragment>
            );
          });
      },
    },
    {
      Header: "Serviço de Acolhimento Atual",
      accessor: "servicoAcolhimentoAtual",
      sortType: (rowA, rowB, id, desc) => {
        const nomeServicoA = rowA?.original?.servicoAcolhimentoAtual
          ? rowA.original.servicoAcolhimentoAtual.nomeFantasia
          : "";
        const nomeServicoB = rowB?.original?.servicoAcolhimentoAtual
          ? rowB.original.servicoAcolhimentoAtual.nomeFantasia
          : "";
        return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
      },
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM,
          ) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.servicoAcolhimentoAtual?.idPessoaJuridica,
            ));
        const temRiscoVida =
          props?.row?.original?.riscoVida === "S" ? true : false;

        if (temRiscoVida && !permissaoServico) {
          return <span></span>;
        } else {
          const idServico = props?.row?.original?.servicoAcolhimentoAtual?.id;
          if (!idServico) {
            return <span></span>;
          } else {
            return (
              <>
                {roleKeycloack &&
                roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
                  <Link
                    wordBreak={"break-word"}
                    title={
                      props?.value
                        ? props?.value?.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""
                    }
                    as={ReactLink}
                    to={"/servico-acolhimento/" + idServico}
                  >
                    <Text>
                      {" "}
                      {props?.value
                        ? props?.value?.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""}
                    </Text>
                  </Link>
                ) : (
                  <Text>
                    {props?.value
                      ? props?.value?.nomeFantasia +
                        `${props?.value?.suspenso === "S" ? " (Suspenso)" : ""}`
                      : ""}
                  </Text>
                )}
              </>
            );
          }
        }
      },
    },
  ];

  useEffect(() => {
    const storage = sessionStorage.getItem(
      "relatorio-crianca-adolescente-geral-filter",
    );

    if (!storage && mostrarTabela) {
      setMostrarTabela(false);
    }
  }, [storage, mostrarTabela]);

  const renderizarTooltip = () => {
    if (isMobile)
      return (
        <PopoverGenero
          isOpen={hintPreliminar}
          setIsOpen={setHintPreliminar}
          flex={true}
          handleClick={() => setHintPreliminar(!hintPreliminar)}
          labelTextoGenero={
            "Durante o período pesquisado é possível que uma criança ou adolescente tenha mais de um movimento. Na versão Excel completo, o resultado da pesquisa exibirá todos esses movimentos."
          }
        />
      );

    return (
      <Tooltip
        label={
          "Durante o período pesquisado é possível que uma criança ou adolescente tenha mais de um movimento. Na versão Excel completo, o resultado da pesquisa exibirá todos esses movimentos."
        }
        fontSize="md"
        maxW="400px"
        textAlign={"justify"}
        placement={placement}
      >
        <span className="hint-tooltip">
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={{ base: "20px" }}
          />
        </span>
      </Tooltip>
    );
  };

  const renderSN = (value) => {
    if (!value || value.length === 0) return "";

    const hasS = value.includes("S");
    const hasN = value.includes("N");

    if (hasS && hasN) return " Sim e Não";
    if (hasS) return " Sim";
    if (hasN) return " Não";

    return "";
  };

  const getExportarExcel = async (tipo) => {
    const idsProcesso = (storage?.idProcesso || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);
    const idsTipoSentenca = (storage?.idTipoSentenca || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);
    const idsProcedimento = (storage?.idProcedimento || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);

    const idsDeficiencias = storage?.deficiencias
      ? (() => {
          const flat = storage?.deficiencias.flat();

          const hasTodos = flat.some((item) => item.id === "");

          if (hasTodos) return [0];

          return flat
            .map((item) => item.idTipoDeficiencia ?? item.value)
            .filter((id) => id !== null && id !== undefined && id !== "");
        })()
      : [];

    const idsDoencas = storage?.doencas
      ? (() => {
          const flat = storage?.doencas.flat();

          const hasTodos = flat.some((item) => item.id === "");

          if (hasTodos) return [0];

          return flat
            .map((item) => item.idDoenca ?? item.value)
            .filter((id) => id !== null && id !== undefined && id !== "");
        })()
      : [];

    const generos = (storage?.idGenero || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);

    const racas = (storage?.idRaca || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);

    const idTipoRef = storage?.idTipoReferencia
      ? (() => {
          const flat = storage?.idTipoReferencia.flat();

          const hasTodos = flat.some((item) => item.id === "");

          if (hasTodos) return [0];

          return flat
            .map((item) => item.id ?? item.value)
            .filter((id) => id !== null && id !== undefined && id !== "");
        })()
      : [];

    const nomeServicosAcolhimentos = (storage?.idsServicosAcolhimento || [])
      ?.flat()
      ?.map((item) => item.nomeFantasia)
      ?.filter(Boolean);

    const idsJustificativas = (storage?.idJustificativas || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);

    const idsMotivo = (storage?.idsMotivosEntrada || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);
    const idsServicos = (storage?.idsServicosAcolhimento || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter(Boolean);
    const municipiosOrgaos = (storage?.idMunicipioOrgao || [])
      ?.flat()
      ?.map((item) => item.id)
      ?.filter((id) => id !== "" && id != null);
    const promotoriasOrgaos = (storage?.idPromotoriaOrgaos || [])
      ?.flat()
      ?.map((item) => ({
        id: item.id,
        idMunicipio: item.idMunicipio,
      }))
      ?.filter((id) => id !== "" && id != null);
    const varasOrgaos = (storage?.idVaraOrgaos || [])
      ?.flat()
      ?.map((item) => ({
        id: item.id,
        idMunicipio: item.idMunicipio,
      }))
      ?.filter((id) => id !== "" && id != null);

    const idadeMin = [storage?.idadeInicial].find(
      (v) => v != null && v !== "" && v !== "null",
    );

    const idadeMax = [storage?.idadeFinal].find(
      (v) => v != null && v !== "" && v !== "null",
    );

    const valuesToSend = {
      tipoRelatorio:
        tipo === "basico"
          ? "RELATORIO_CRIANCA_ADOLESCENTES_BASICO_GESTOR"
          : "RELATORIO_CRIANCA_ADOLESCENTES_COMPLETO_GESTOR",
      universoConsulta: {
        universo:
          storage?.universoConsulta === 1
            ? "ACOLHIDO"
            : storage?.universoConsulta === 2
              ? "DESLIGADO"
              : storage?.universoConsulta === 3
                ? "TRANSFERENCIA"
                : "PENDENTE",
        idsServicosAcolhimento: idsServicos,
        idsMotivosEntrada: idsMotivo,
        tipoPeriodo:
          storage?.tipoPeriodo === "A"
            ? "SITUACAO_ATUAL"
            : storage?.tipoPeriodo === "D"
              ? "DATA"
              : "",

        entradasPorTransferencias: storage?.entradasPorTransferencias?.includes(
          "Possui",
        )
          ? true
          : false,
        saidaTransferencia: storage?.saidaTransferencia?.includes("Possui")
          ? true
          : false,
        maioresDezoito: storage?.maioresDezoito?.includes("Possui")
          ? true
          : false,
        dataInicio: storage?.dataInicio
          ? formatDateToISOWithNow(storage?.dataInicio)
          : "",
        dataFim: storage?.dataFim
          ? formatDateToISOWithNow(storage?.dataFim)
          : "",
        idJustificativas: idsJustificativas,
        idTipoTransferencia: storage?.idTipoTransferencia?.id
          ? storage?.idTipoTransferencia?.id
          : null,
      },

      localizacaoServicoAcolhimento: {
        estados: storage?.idEstado
          ? storage?.idEstado
              .flat()
              .map((item) => item.id)
              .filter((item) => item.id !== "")
          : [],
        municipios: storage?.idMunicipio
          ? storage?.idMunicipio
              .flat()
              .map((item) => ({
                id: item.id,
                idEstado: item.idEstado,
              }))
              .filter((item) => item.id !== "")
          : [],
        bairros: storage?.idBairro
          ? storage?.idBairro
              .flat()
              .map((item) => ({
                id: item.id,
                idMunicipio: item.idMunicipio,
              }))
              .filter((item) => item.id !== "")
          : [],
        nomeServicosAcolhimentos: nomeServicosAcolhimentos,
      },

      orgaos: cleanObject({
        municipios: municipiosOrgaos,
        promotorias: promotoriasOrgaos,
        varasInfancias: varasOrgaos,
        orgaoConstaFichaCriancaAdoslecente:
          storage?.radioCriterioAtribuicaoCompetencia === "C" ? true : false,
        orgaoConstaFichaServicoAcolhimento:
          storage?.radioCriterioAtribuicaoCompetencia === "S" ? true : false,
        mesmoOrgaoFichaCriancaAdoslecenteEFichaServicoAcolhimento:
          storage?.radioCriterioAtribuicaoCompetencia === "CS" ? true : false,
      }),

      dadosBasicos: cleanObject({
        generos: generos,
        racasCores: racas,
        faixaEtariaDe: idadeMin,
        faixaEtariaAte: idadeMax,
        comNomeSocial: storage?.pesquisarFichas?.includes("S") ? true : "",
        comNomeFicticio: storage?.pesquisarFichas?.includes("F") ? true : "",
        comDataNascimentoEstimada: storage?.pesquisarFichas?.includes("N")
          ? true
          : "",
      }),
      referenciaFamiliarComunitaria: cleanObject({
        tiposReferencia: idTipoRef,
        nomeReferencia: storage?.nomeReferencia,
        irmaosMesmoServico: storage?.detalhamentoIrmaos?.includes("A")
          ? true
          : "",
        irmaosServicosDiferentes: storage?.detalhamentoIrmaos?.includes("AD")
          ? true
          : "",
        irmaosSemHistoricoAcolhimento: storage?.detalhamentoIrmaos?.includes(
          "H",
        )
          ? true
          : "",
        irmaosDesligados: storage?.detalhamentoIrmaos?.includes("D")
          ? true
          : "",
      }),
      saude: cleanObject({
        possuiDeficiencia: parseBoolean(storage?.radioDeficiencia),
        tiposDeficiencia: idsDeficiencias,
        possuiProblemaSaude: parseBoolean(storage?.radioProblemaSaude),
        tiposDoenca: idsDoencas,
        cartaoVacinacao:
          storage?.radioCartaoVacinacao.length > 0
            ? storage?.radioCartaoVacinacao
            : [],
        usaMedicacaoContinua: parseBoolean(storage?.radioMedicacaoContinua),
      }),
      educacao: cleanObject({
        frequentaEscola: parseBoolean(storage?.radioFrequentaEscola),
        educacaoEspecial: parseBoolean(storage?.radioEducacaoEspecial),
        escolaridadeRepetida: parseBoolean(storage?.radioEscolaridadeRepetida),
      }),
      profissionalizacao: cleanObject({
        possuiCursoProfissionalizante: parseBoolean(storage?.radioPossuiCurso),
        trabalhaAtualmente: parseBoolean(storage?.radioTrabalhaAtualmente),
        fazEstagio: parseBoolean(storage?.radioFazEstagio),
        matriculadoJovemAprendiz: parseBoolean(storage?.radioJovemAprendiz),
        possuiCurriculoVitae: parseBoolean(storage?.radioCurriculoVitae),
      }),

      ...(storage?.radioRecebeVisita &&
        typeof storage?.radioRecebeVisita === "string" && {
          visita: cleanObject({
            recebeVisita: parseBoolean(storage?.radioRecebeVisita),
            faixaPeriodo:
              storage?.faixaPeriodo?.id === 1
                ? "NO_MES"
                : storage?.faixaPeriodo?.id === 2
                  ? "ULTIMOS_3_MESES"
                  : storage?.faixaPeriodo?.id === 3
                    ? "ULTIMOS_6_MESES"
                    : storage?.faixaPeriodo?.id === 4
                      ? "EM_QUALQUER_PERIODO"
                      : "EM_QUALQUER_PERIODO",
          }),
        }),

      situacaoJuridica: cleanObject({
        possuiProcessoJudicial: parseBoolean(
          storage?.radioPossuiProcessoJudicial,
        ),
        tiposProcesso: idsProcesso,
        possuiProcedimentoJudicial: parseBoolean(
          storage?.radioPossuiProcedimentoJudicial,
        ),
        tiposProcedimento: idsProcedimento,
        haDecisaoLiminarFamiliaSubstituta: parseBoolean(
          storage?.radioDecisaoLiminar,
        ),
        possuiSentenca: parseBoolean(storage?.radioSentenca),
        tiposSentenca: idsTipoSentenca,
        recurso:
          storage?.radioRecurso === "S"
            ? "S"
            : storage?.radioRecurso === "N"
              ? "N"
              : storage?.radioRecurso === "I"
                ? "I"
                : "",
        transitoEmJulgado: parseBoolean(storage?.radioTransitoJulgado),
      }),
      situacaoAdocao: {
        cumpreRequisitosAdocao: parseBoolean(storage?.radioCumpreRequisito),
      },

      ...(storage?.radioIncluidoPrograma &&
        typeof storage?.radioIncluidoPrograma === "string" && {
          programaApadrinhamento: cleanObject({
            incluidoProgramaApadrinhamento:
              storage?.radioIncluidoPrograma === "S"
                ? "SIM"
                : storage?.radioIncluidoPrograma === "N"
                  ? "NAO"
                  : storage?.radioIncluidoPrograma === "SI"
                    ? "SEM_INFORMACAO"
                    : "",
            sendoApadrinhado:
              storage?.radioSendoApadrinhado === "S"
                ? "SIM"
                : storage?.radioSendoApadrinhado === "N"
                  ? "NAO"
                  : storage?.radioSendoApadrinhado === "SI"
                    ? "SEM_INFORMACAO"
                    : "SEM_INFORMACAO",
          }),
        }),
    };

    try {
      setLoadingExcel(true);
      await RelatorioService.getExecelListaRelatorioCriancaAdolescenteGeral(
        valuesToSend,
      );

      Swal.fire({
        title: "Em processamento",
        html: `<div style="text-align: center;">Este relatório está sendo processado em segundo plano. <br /> Para acompanhar, verifique a sua fila de processamento localizado no <br /> menu lateral do sistema.</div>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Ir para Fila de Processamento",
        cancelButtonText: "Fechar",
        width: "600px",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/fila-processamento");
        }
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error?.response?.data?.message : "",
        icon: "error",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const [data, setData] = useState();
  const isDisabled = loadingExcel || !data?.content?.length;

  return roleKeycloack ? (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Group
        mt={1}
        title={"Relatório de Crianças e Adolescentes"}
        opcoes={true}
        dividerFalse={true}
      >
        <>
          <Box mt={4}>
            <FiltersRelatorioCriancaGeral
              data={data}
              setData={setData}
              setLoading={setLoading}
              loading={loading}
              entidade="relatorio-crianca-adolescente-geral"
              user={user}
              roleKeycloack={roleKeycloack}
              atualizarDadosTabela={atualizarDadosTabela}
              setAtualizarDadosTabela={setAtualizarDadosTabela}
              setMostrarTabela={setMostrarTabela}
              mostrarTabela={mostrarTabela}
            >
              <TabPanels>
                <TabPanel>
                  {
                    <>
                      {mostrarTabela && (
                        <>
                          {!loading && data ? (
                            <>
                              <Text
                                mt={4}
                                fontWeight={700}
                                fontSize="18px"
                                lineHeight="136%"
                                color={`#169499`}
                              >
                                Relatório Gerado:
                              </Text>

                              <Flex
                                mt={4}
                                alignItems="center"
                                gap={2}
                                flexWrap="wrap"
                                maxWidth="100%"
                              >
                                <Text color="#575553">
                                  {`Data da Geração: ${format(
                                    new Date(),
                                    "dd/MM/yyyy",
                                  )} ${format(new Date(), "HH")}h${format(
                                    new Date(),
                                    "mm",
                                  )}`}
                                </Text>
                              </Flex>

                              <Flex
                                mt={4}
                                alignItems="center"
                                justifyContent="end"
                                gap={4}
                              >
                                <PrintButtonRelatorioCriancaGeral
                                  user={user}
                                  entidade={
                                    "relatorio-crianca-adolescente-geral"
                                  }
                                  dados={usuarioLogado}
                                  roleKeycloack={roleKeycloack}
                                />

                                <Menu>
                                  {({ isOpen }) => (
                                    <>
                                      <MenuButton
                                        type="button"
                                        cursor={
                                          isDisabled ? "not-allowed" : "pointer"
                                        }
                                        pointerEvents={
                                          isDisabled ? "none" : "auto"
                                        }
                                      >
                                        <Flex alignItems="center" gap={2}>
                                          <Flex
                                            bg={
                                              isDisabled ? "#A9A9A9" : "#006400"
                                            }
                                            rounded="full"
                                            p={1}
                                          >
                                            <RiFileExcel2Line color="white" />
                                          </Flex>

                                          <Text
                                            as="b"
                                            color={
                                              isDisabled ? "#A9A9A9" : "#006400"
                                            }
                                            fontSize="md"
                                          >
                                            Exportar em Excel
                                          </Text>

                                          {!isDisabled && (
                                            <Icon
                                              as={ChevronDownIcon}
                                              color="#006400"
                                              boxSize={6}
                                              transition="transform 0.2s"
                                              transform={
                                                isOpen
                                                  ? "rotate(180deg)"
                                                  : "rotate(0deg)"
                                              }
                                            />
                                          )}
                                        </Flex>
                                      </MenuButton>

                                      <MenuList>
                                        <MenuItem
                                          cursor={"pointer"}
                                          pr={6}
                                          py={3}
                                          justifyContent="space-between"
                                          as="strong"
                                          onClick={() =>
                                            !isDisabled &&
                                            getExportarExcel("basico")
                                          }
                                        >
                                          Básico{" "}
                                          <FaDownload
                                            color="#006064"
                                            size={16}
                                          />
                                        </MenuItem>
                                        <MenuItem
                                          cursor={"pointer"}
                                          pr={6}
                                          py={3}
                                          justifyContent="space-between"
                                          as="strong"
                                          onClick={() =>
                                            !isDisabled &&
                                            getExportarExcel("completo")
                                          }
                                        >
                                          Completo{" "}
                                          <FaDownload
                                            color="#006064"
                                            size={16}
                                          />
                                        </MenuItem>
                                      </MenuList>
                                    </>
                                  )}
                                </Menu>
                                {(storage?.tipoPeriodo === "D" ||
                                  storage?.dataInicio ||
                                  storage?.dataFim) && (
                                  <> {renderizarTooltip()} </>
                                )}
                              </Flex>

                              <TableRelatorioPendencia
                                data={data.content}
                                columns={columns}
                                isOpenNovoAcolhimento={isOpenNovoAcolhimento}
                                onOpenNovoAcolhimento={onOpenNovoAcolhimento}
                                onCloseNovoAcolhimento={onCloseNovoAcolhimento}
                                entidade="relatorio-crianca-adolescente-geral"
                                atualizarDadosTabela={atualizarDadosTabela}
                                setAtualizarDadosTabela={
                                  setAtualizarDadosTabela
                                }
                                roleKeycloack={roleKeycloack}
                                user={user}
                                setData={setData}
                                idPJ={idPJ}
                              />
                            </>
                          ) : (
                            <Box mt={4}>
                              <LoadingSpinner />
                            </Box>
                          )}
                        </>
                      )}
                    </>
                  }
                </TabPanel>

                <TabPanel px={0}>
                  <Flex
                    direction="column"
                    borderRadius="12px"
                    boxShadow="0px 24px 40px 0px #00000014"
                    border="1px solid #00000014"
                    mt={4}
                    px={25}
                    py={10}
                  >
                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Universo da Consulta
                    </Text>
                    {(!!storage?.universoConsulta ||
                      (!!storage?.idsMotivosEntrada &&
                        storage?.idsMotivosEntrada?.length > 0) ||
                      !!storage?.idTipoTransferencia ||
                      (!!storage?.idJustificativas &&
                        storage?.idJustificativas?.length > 0) ||
                      (!!storage?.dataInicio && !!storage?.dataFim)) && (
                      <>
                        <SimpleGrid
                          columns={
                            storage?.idsMotivosEntrada?.length > 0 ||
                            !!storage?.idTipoTransferencia
                              ? 3
                              : 2
                          }
                          spacing={3}
                          w="100%"
                          mt={10}
                        >
                          {/* HEADER */}
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Universo
                          </Text>
                          {storage?.idsMotivosEntrada?.[0]?.length > 0 && (
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Motivo
                            </Text>
                          )}
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Período
                          </Text>
                          {storage?.idTipoTransferencia && (
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Tipo de Transferência
                            </Text>
                          )}

                          <Box>
                            <Text borderBottom="1px solid #00000014" p={1}>
                              {storage?.universoConsulta === 1
                                ? "Acolhido"
                                : storage?.universoConsulta === 2
                                  ? "Desligado"
                                  : storage?.universoConsulta === 3
                                    ? "Transferência"
                                    : storage?.universoConsulta === 4
                                      ? "Pendente"
                                      : ""}
                            </Text>
                          </Box>

                          {storage?.idsMotivosEntrada?.[0]?.length > 0 && (
                            <Box>
                              <Text borderBottom="1px solid #00000014" p={1}>
                                {storage?.idsMotivosEntrada?.[0]
                                  ?.map((e) => e.descricao)
                                  .join(", ")}
                              </Text>
                            </Box>
                          )}

                          <Box>
                            {storage?.dataInicio || storage?.dataFim ? (
                              <Text borderBottom="1px solid #00000014" p={1}>
                                {storage?.dataInicio
                                  ? `De ${storage?.dataInicio}`
                                  : ""}{" "}
                                {storage?.dataFim
                                  ? `Até ${storage?.dataFim}`
                                  : ""}
                              </Text>
                            ) : (
                              <Text borderBottom="1px solid #00000014" p={1}>
                                Situação Atual
                              </Text>
                            )}
                          </Box>

                          {!!storage?.idTipoTransferencia && (
                            <Box>
                              <Text borderBottom="1px solid #00000014" p={1}>
                                {storage?.idTipoTransferencia?.label}
                              </Text>
                            </Box>
                          )}
                        </SimpleGrid>

                        <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                          {storage?.idJustificativas?.[0]?.length > 0 && (
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Justificativas
                            </Text>
                          )}

                          {storage?.idJustificativas?.[0]?.length > 0 && (
                            <Box>
                              <Text borderBottom="1px solid #00000014" p={1}>
                                {storage?.idJustificativas?.[0]
                                  ?.map((e) => e.descricao)
                                  .join(", ")}
                              </Text>
                            </Box>
                          )}
                        </SimpleGrid>
                      </>
                    )}

                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Localização do Serviço de Acolhimento
                    </Text>
                    <SimpleGrid columns={4} spacing={3} w="100%" mt={10}>
                      {/* HEADER */}
                      <Text
                        fontWeight="bold"
                        color="#169499"
                        borderBottom="1px solid #00000014"
                      >
                        Estado
                      </Text>
                      <Text
                        fontWeight="bold"
                        color="#169499"
                        borderBottom="1px solid #00000014"
                      >
                        Município
                      </Text>
                      <Text
                        fontWeight="bold"
                        color="#169499"
                        borderBottom="1px solid #00000014"
                      >
                        Bairro
                      </Text>
                      <Text
                        fontWeight="bold"
                        color="#169499"
                        borderBottom="1px solid #00000014"
                      >
                        Nome do Serviço de Acolhimento
                      </Text>

                      {/* LINHA ÚNICA */}
                      <Text borderBottom="1px solid #00000014">
                        {storage?.idEstado?.[0]
                          ?.map((e) => e.nome)
                          .join(", ") || "Todos"}
                      </Text>

                      <Text borderBottom="1px solid #00000014">
                        {storage?.idMunicipio?.[0]?.[0]?.descricao === "Todos"
                          ? "Todos"
                          : storage?.idMunicipio?.[0]
                              ?.map((m) => m.descricao)
                              .join(", ") || "Todos"}
                      </Text>

                      <Text borderBottom="1px solid #00000014">
                        {storage?.idBairro?.[0]?.[0]?.descricao === "Todos"
                          ? "Todos"
                          : storage?.idBairro?.[0]
                              ?.map((b) => b.descricao)
                              .join(", ") || "Todos"}
                      </Text>

                      <Text borderBottom="1px solid #00000014">
                        {storage?.idsServicosAcolhimento?.[0]
                          ?.map((e) => e.nomeFantasia)
                          .join(", ") || "Todos"}
                      </Text>
                    </SimpleGrid>
                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Orgãos
                    </Text>

                    {((storage?.idMunicipioOrgao?.length ?? 0) > 0 ||
                      (storage?.idPromotoriaOrgaos?.length ?? 0) > 0 ||
                      (storage?.idVaraOrgaos?.length ?? 0) > 0) && (
                      <SimpleGrid
                        columns={columnsOrgaos}
                        spacing={3}
                        w="100%"
                        mt={10}
                      >
                        {/* HEADER */}

                        {storage?.idMunicipioOrgao?.[0]?.length > 0 && (
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Município
                          </Text>
                        )}

                        {storage?.idPromotoriaOrgaos?.[0]?.length > 0 && (
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Promotoria de Justiça
                          </Text>
                        )}

                        {storage?.idVaraOrgaos?.[0]?.length > 0 && (
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Vara da Infância
                          </Text>
                        )}

                        {/* LINHA ÚNICA */}
                        {storage?.idMunicipioOrgao?.[0]?.length > 0 && (
                          <Text borderBottom="1px solid #00000014">
                            {storage?.idMunicipioOrgao?.[0]
                              ?.map((e) => e.descricao)
                              .join(", ")}
                          </Text>
                        )}

                        {storage?.idPromotoriaOrgaos?.[0]?.length > 0 && (
                          <Text borderBottom="1px solid #00000014">
                            {storage?.idPromotoriaOrgaos?.[0]
                              ?.map((m) => m.descricao)
                              .join(", ")}
                          </Text>
                        )}

                        {storage?.idVaraOrgaos?.[0]?.length > 0 && (
                          <Text borderBottom="1px solid #00000014">
                            {storage?.idVaraOrgaos?.[0]
                              ?.map((e) => e.descricao)
                              .join(", ")}
                          </Text>
                        )}
                      </SimpleGrid>
                    )}

                    {!!storage?.radioCriterioAtribuicaoCompetencia && (
                      <>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                          mt={6}
                        >
                          Critério de Atribuição
                        </Text>
                        <List styleType="disc" p={5}>
                          <ListItem>
                            {storage?.radioCriterioAtribuicaoCompetencia === "C"
                              ? "Órgão que consta na Ficha Criança ou Adolescente "
                              : storage?.radioCriterioAtribuicaoCompetencia ===
                                  "S"
                                ? "Órgão que consta na Ficha do Serviço de Acolhimento "
                                : storage?.radioCriterioAtribuicaoCompetencia ===
                                    "SC"
                                  ? "Mesmo Órgão na Ficha da Criança ou Adolescente e Ficha do Serviço de Acolhimento "
                                  : ""}
                          </ListItem>
                        </List>
                      </>
                    )}
                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Dados Básicos
                    </Text>

                    {((storage?.idGenero?.length ?? 0) > 0 ||
                      (storage?.idRaca?.length ?? 0) > 0) && (
                      <SimpleGrid columns={2} spacing={3} w="100%" mt={10}>
                        {/* HEADER */}

                        {storage?.idGenero?.[0]?.length > 0 && (
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Gênero
                          </Text>
                        )}

                        {storage?.idRaca?.[0]?.length > 0 && (
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Raça/Cor
                          </Text>
                        )}

                        {/* LINHA ÚNICA */}
                        <Text>
                          {storage?.idGenero?.[0]
                            ?.map((e) => e.genero || e?.descricao)
                            .join(", ")}
                        </Text>

                        <Text>
                          {storage?.idRaca?.[0]
                            ?.map((m) => m.raca || m?.descricao)
                            .join(", ")}
                        </Text>
                      </SimpleGrid>
                    )}
                    {(storage?.idadeInicial || storage?.idadeFinal) && (
                      <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Faixa Etária Pesquisada
                        </Text>

                        <Text>
                          {storage?.idadeInicial &&
                            `De: ${storage?.idadeInicial} Anos`}{" "}
                          {storage?.idadeFinal &&
                            `Até 
                            ${storage?.idadeFinal} Anos`}
                        </Text>
                      </SimpleGrid>
                    )}
                    {storage?.pesquisarFichas?.length > 0 && (
                      <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Fichas
                        </Text>

                        <Text>
                          {storage?.pesquisarFichas.includes("S") &&
                            "Cadastros com Nome Social"}
                        </Text>
                        <Text>
                          {storage?.pesquisarFichas.includes("F") &&
                            " Cadastros com Nome Fictício"}
                        </Text>
                        <Text>
                          {storage?.pesquisarFichas.includes("N") &&
                            "Cadastro com Data de Nascimento Estimada"}
                        </Text>
                      </SimpleGrid>
                    )}
                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Referência Familiar e Comunitária
                    </Text>
                    {(storage?.idTipoReferencia?.length ?? 0) > 0 && (
                      <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Tipo de Referência
                        </Text>

                        <Text>
                          {storage?.idTipoReferencia?.[0]
                            ?.map((e) => e.label || e?.descricao)
                            .join(", ") || "Todos"}
                        </Text>
                      </SimpleGrid>
                    )}
                    {storage?.nomeReferencia && (
                      <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Nome da Referência Familiar
                        </Text>

                        <Text>{storage?.nomeReferencia}</Text>
                      </SimpleGrid>
                    )}
                    {storage?.detalhamentoIrmaos?.length > 0 && (
                      <>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                          mt={6}
                        >
                          Detalhamento de Irmãos
                        </Text>
                        <List styleType="disc" p={5}>
                          {storage?.detalhamentoIrmaos.includes("A") && (
                            <ListItem>
                              Irmão(s) acolhido(s) no mesmo serviço de
                              acolhimento. 
                            </ListItem>
                          )}

                          {storage?.detalhamentoIrmaos.includes("AD") && (
                            <ListItem>
                              Irmão(s) acolhido(s) em serviço(s) de acolhimento
                              diferente(s).
                            </ListItem>
                          )}

                          {storage?.detalhamentoIrmaos.includes("H") && (
                            <ListItem>
                              Irmão(s) sem histórico de acolhimento.
                            </ListItem>
                          )}

                          {storage?.detalhamentoIrmaos.includes("D") && (
                            <ListItem>Irmão(s) desligado(s). </ListItem>
                          )}
                        </List>
                      </>
                    )}
                    <Text
                      borderBottom="3px solid #169499"
                      pb={2}
                      as="b"
                      fontSize={"18px"}
                      display="inline-flex"
                      alignItems="center"
                      gap={2}
                      mr={2}
                      mt={10}
                      w="fit-content"
                    >
                      <RiPushpinLine size={20} />
                      Saúde
                    </Text>
                    {(storage?.radioDeficiencia?.length ?? 0) > 0 && (
                      <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                        {/* HEADER */}
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Deficiência
                        </Text>

                        <Text p={1}>{renderSN(storage.radioDeficiencia)}</Text>
                      </SimpleGrid>
                    )}
                    {(storage?.deficiencias?.length ?? 0) > 0 && (
                      <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Tipo Deficiência
                        </Text>

                        <List styleType="disc" px={5}>
                          {storage.deficiencias[0].map((e) => (
                            <ListItem key={e?.idTipoDeficiencia || e?.id}>
                              {e?.descricaoTipoDeficiencia || e?.descricao}
                            </ListItem>
                          ))}
                        </List>
                      </SimpleGrid>
                    )}
                    {(storage?.radioProblemaSaude?.length ?? 0) > 0 && (
                      <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                        {" "}
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Problema de Saúde
                        </Text>
                        <Text p={1}>
                          {renderSN(storage.radioProblemaSaude)}
                        </Text>
                      </SimpleGrid>
                    )}
                    {(storage?.doencas?.length ?? 0) > 0 && (
                      <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                        {" "}
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Doenças
                        </Text>
                        <List styleType="disc" px={5}>
                          {storage.doencas[0].map((e) => (
                            <ListItem key={e.idDoenca || e.id}>
                              {e?.descricaoDoenca || e?.descricao}
                            </ListItem>
                          ))}
                        </List>
                      </SimpleGrid>
                    )}
                    {(storage?.radioCartaoVacinacao?.length ?? 0) > 0 && (
                      <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                        {" "}
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Cartão Vacinação
                        </Text>
                        <Text p={1}>
                          <Text>
                            {storage?.radioCartaoVacinacao.includes("SIM") &&
                              "Sim"}
                          </Text>
                          <Text>
                            {storage?.radioCartaoVacinacao.includes("NAO") &&
                              "Não"}
                          </Text>
                          <Text>
                            {storage?.radioCartaoVacinacao.includes(
                              "SEM_INFORMACAO",
                            ) && "Sem Informação"}
                          </Text>
                        </Text>
                      </SimpleGrid>
                    )}
                    {(storage?.medicacaoContinua?.length ?? 0) > 0 && (
                      <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                        {" "}
                        <Text
                          fontWeight="bold"
                          color="#169499"
                          borderBottom="1px solid #00000014"
                        >
                          Medicação Continua
                        </Text>
                        <Text p={1}>{renderSN(storage.medicacaoContinua)}</Text>
                      </SimpleGrid>
                    )}
                    <>
                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        mt={10}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Educação
                      </Text>

                      {((storage?.radioFrequentaEscola?.length ?? 0) > 0 ||
                        (storage?.radioEducacaoEspecial?.length ?? 0) > 0 ||
                        (storage?.radioEscolaridadeRepetida?.length ?? 0)) >
                        0 && (
                        <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                          {/* HEADER */}
                          {(storage?.radioFrequentaEscola?.length ?? 0) > 0 && (
                            <Box>
                              <Text p={1}>
                                Frequenta Escola:{" "}
                                {renderSN(storage?.radioFrequentaEscola)}
                              </Text>
                            </Box>
                          )}

                          {(storage?.radioEducacaoEspecial?.length ?? 0) >
                            0 && (
                            <Box>
                              <Text p={1}>
                                Educação Especial:{" "}
                                {renderSN(storage?.radioEducacaoEspecial)}
                              </Text>
                            </Box>
                          )}
                          {(storage?.radioEscolaridadeRepetida?.length ?? 0) >
                            0 && (
                            <Box>
                              <Text p={1}>
                                Escolaridade Repetida:{" "}
                                {renderSN(storage?.radioEscolaridadeRepetida)}
                              </Text>
                            </Box>
                          )}
                        </SimpleGrid>
                      )}

                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        mt={10}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Profissionalização
                      </Text>
                      {((storage?.radioPossuiCurso?.length ?? 0) > 0 ||
                        (storage?.radioTrabalhaAtualmente?.length ?? 0) > 0 ||
                        (storage?.radioFazEstagio?.length ?? 0) > 0) && (
                        <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                          {/* HEADER */}

                          {(storage?.radioPossuiCurso?.length ?? 0) > 0 && (
                            <Box>
                              <Text p={1}>
                                Possui Curso Profissionalizante:{" "}
                                {renderSN(storage?.radioPossuiCurso)}
                              </Text>
                            </Box>
                          )}
                          {(storage?.radioTrabalhaAtualmente?.length ?? 0) >
                            0 && (
                            <Box>
                              <Text p={1}>
                                Trabalha Atualmente:{" "}
                                {renderSN(storage?.radioTrabalhaAtualmente)}
                              </Text>
                            </Box>
                          )}
                          {(storage?.radioFazEstagio?.length ?? 0) > 0 && (
                            <Box>
                              <Text p={1}>
                                Faz Estágio:{" "}
                                {renderSN(storage?.radioFazEstagio)}
                              </Text>
                            </Box>
                          )}
                        </SimpleGrid>
                      )}

                      {((storage?.radioJovemAprendiz?.length ?? 0) > 0 ||
                        (storage?.radioCurriculoVitae?.length ?? 0) > 0) && (
                        <SimpleGrid columns={3} spacing={3} w="100%">
                          {/* HEADER */}
                          {(storage?.radioJovemAprendiz?.length ?? 0) > 0 && (
                            <Box>
                              <Text p={1}>
                                Matriculado no Programa Jovem Aprendiz:{" "}
                                {renderSN(storage?.radioJovemAprendiz)}
                              </Text>
                            </Box>
                          )}
                          {(storage?.radioCurriculoVitae?.length ?? 0) > 0 && (
                            <Box>
                              <Text p={1}>
                                Possui Currículo Vitae:{" "}
                                {renderSN(storage?.radioCurriculoVitae)}
                              </Text>
                            </Box>
                          )}
                        </SimpleGrid>
                      )}
                      <>
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Visita
                        </Text>

                        {(storage?.radioRecebeVisita?.length ?? 0) > 0 && (
                          <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                            {/* HEADER */}

                            <Box>
                              <Text p={1}>
                                Recebe Visita?{" "}
                                {renderSN(storage?.radioRecebeVisita)}
                              </Text>
                            </Box>
                          </SimpleGrid>
                        )}

                        {storage?.faixaPeriodo && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {/* HEADER */}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Faixa de Período
                            </Text>

                            <Text p={1}>
                              {storage?.faixaPeriodo?.id === 1
                                ? "No Mês"
                                : storage?.faixaPeriodo?.id === 2
                                  ? "Nos Últimos 3 Meses"
                                  : storage?.faixaPeriodo?.id === 3
                                    ? "Nos Últimos 6 Meses"
                                    : storage?.faixaPeriodo?.id === 4
                                      ? "Em Qualquer Período"
                                      : "Em Qualquer Período"}
                            </Text>
                          </SimpleGrid>
                        )}
                      </>
                      <>
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Situação Jurídica{" "}
                        </Text>

                        {(storage?.radioPossuiProcessoJudicial?.length ?? 0) >
                          0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {/* HEADER */}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Processo Judicial
                            </Text>

                            <Text p={1}>
                              {renderSN(storage.radioPossuiProcessoJudicial)}
                            </Text>
                          </SimpleGrid>
                        )}

                        {(storage?.idProcesso?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Tipo de Processo Judicial
                            </Text>

                            <List styleType="disc" px={5}>
                              {storage.idProcesso[0].map((e) => (
                                <ListItem key={e?.id}>{e?.descricao}</ListItem>
                              ))}
                            </List>
                          </SimpleGrid>
                        )}

                        {(storage?.radioPossuiProcedimentoJudicial?.length ??
                          0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {/* HEADER */}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Procedimento Judicial
                            </Text>

                            <Text p={1}>
                              {renderSN(
                                storage.radioPossuiProcedimentoJudicial,
                              )}
                            </Text>
                          </SimpleGrid>
                        )}

                        {(storage?.idProcedimento?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Tipo de Procedimento Judicial
                            </Text>

                            <List styleType="disc" px={5}>
                              {storage.idProcedimento[0].map((e) => (
                                <ListItem key={e?.id}>{e?.descricao}</ListItem>
                              ))}
                            </List>
                          </SimpleGrid>
                        )}
                        {(storage?.radioDecisaoLiminar?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Decisão Liminar
                            </Text>
                            <Text p={1}>
                              {renderSN(storage.radioDecisaoLiminar)}
                            </Text>
                          </SimpleGrid>
                        )}

                        {(storage?.radioSentenca?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Sentença
                            </Text>
                            <Text p={1}>{renderSN(storage.radioSentenca)}</Text>
                          </SimpleGrid>
                        )}

                        {(storage?.idTipoSentenca?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Tipo de Sentença
                            </Text>
                            <List styleType="disc" px={5}>
                              {storage.idTipoSentenca[0].map((e) => (
                                <ListItem key={e.id}>{e?.descricao}</ListItem>
                              ))}
                            </List>
                          </SimpleGrid>
                        )}

                        {(storage?.radioRecurso?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Recurso
                            </Text>
                            <Text p={1}>
                              <Text>
                                {storage?.radioRecurso === "S" && "Sim"}
                              </Text>
                              <Text>
                                {storage?.radioRecurso === "N" && "Não"}
                              </Text>
                              <Text>
                                {storage?.radioRecurso === "I" &&
                                  "Sem Informação"}
                              </Text>
                            </Text>
                          </SimpleGrid>
                        )}

                        {(storage?.radioTransitoJulgado?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Trânsito em Julgado
                            </Text>
                            <Text p={1}>
                              {renderSN(storage.radioTransitoJulgado)}
                            </Text>
                          </SimpleGrid>
                        )}

                        {(storage?.radioDecisaoLiminar?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Medicação Continua
                            </Text>
                            <Text p={1}>
                              {renderSN(storage.radioDecisaoLiminar)}
                            </Text>
                          </SimpleGrid>
                        )}

                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Situação quanto à adoção
                        </Text>

                        {(storage?.radioCumpreRequisito?.length ?? 0) > 0 && (
                          <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                            {/* HEADER */}

                            <Box>
                              <Text p={1}>
                                Cumpre Requisitos para Adoção:{" "}
                                {renderSN(storage?.radioCumpreRequisito)}
                              </Text>
                            </Box>
                          </SimpleGrid>
                        )}
                      </>

                      <Text
                        borderBottom="3px solid #169499"
                        pb={2}
                        as="b"
                        fontSize={"18px"}
                        display="inline-flex"
                        alignItems="center"
                        gap={2}
                        mr={2}
                        mt={10}
                        w="fit-content"
                      >
                        <RiPushpinLine size={20} />
                        Programa de Apadrinhamento
                      </Text>

                      {((storage?.radioIncluidoPrograma?.length ?? 0) > 0 ||
                        (storage?.radioSendoApadrinhado?.length ?? 0) > 0) && (
                        <SimpleGrid columns={3} spacing={3} w="100%" mt={10}>
                          {/* HEADER */}

                          {(storage?.radioIncluidoPrograma?.length ?? 0) >
                            0 && (
                            <Box>
                              <Text p={1}>
                                Está Incluído no Programa de Apadrinhamento:{" "}
                                <Text>
                                  {storage?.radioIncluidoPrograma === "S" &&
                                    "Sim"}
                                </Text>
                                <Text>
                                  {storage?.radioIncluidoPrograma === "N" &&
                                    "Não"}
                                </Text>
                                <Text>
                                  {storage?.radioIncluidoPrograma === "SI" &&
                                    "Sem Informação"}
                                </Text>
                              </Text>
                            </Box>
                          )}
                          {(storage?.radioSendoApadrinhado?.length ?? 0) >
                            0 && (
                            <Box>
                              <Text p={1}>
                                Está Sendo Apadrinhado:{" "}
                                <Text>
                                  {storage?.radioSendoApadrinhado === "S" &&
                                    "Sim"}
                                </Text>
                                <Text>
                                  {storage?.radioSendoApadrinhado === "N" &&
                                    "Não"}
                                </Text>
                                <Text>
                                  {storage?.radioSendoApadrinhado === "SI" &&
                                    "Sem Informação"}
                                </Text>
                              </Text>
                            </Box>
                          )}
                        </SimpleGrid>
                      )}
                    </>
                  </Flex>
                </TabPanel>
              </TabPanels>
            </FiltersRelatorioCriancaGeral>
          </Box>
        </>
      </Group>
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
